export const sortInterests = (a, b) => (a !== b ? (a < b ? -1 : 1) : 0);